<navbar class="fixed top-0 inset-x-0 z-30"></navbar>

<div class="flex h-screen pt-12 bg-background-surface">
  <sidebar class="shrink-0 border-r border-gray-200"></sidebar>

  <div class="flex flex-1 flex-col min-w-0 overflow-hidden">
    <main class="flex-1 overflow-y-auto p-6" resetScrollOnNavigate>
      <div class="w-full">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>